const MINIMAL_PASSWORD_LENGHT = 6;

const validations = [

  // Validate password lenght
  (password) => {
    const validate = password && typeof password === 'string' && password.length > MINIMAL_PASSWORD_LENGHT;

    return validate === true ? null : `Password should have at least ${MINIMAL_PASSWORD_LENGHT} characters`;
  },
];

/**
  * Runs your provided password against a series of validations defined by the developers
  * @param {string} password
  *
  */

export const validatePassword = (password) => validations.map(validation => validation(password)).filter(validationError => (validationError != null));
export default {
  validatePassword,
};
